import React from 'react';
import classNames from './style.module.scss';

interface NoticeProps {
	children: React.ReactNode;
	title: string;
}

const Notice: React.FC<NoticeProps> = ({ children, title }) => {
	return (
		<div className={classNames.notice}>
			<h2>
				<i className="bi bi-info-circle"></i>
				<span>{title}</span>
			</h2>

			{children}
		</div>
	);
};

export default Notice;
